module.exports = __webpack_public_path__ + "img/NPR.cf037cd0.svg";